import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Card from "../Cards/Card";
import ComboHeader from "../../components/ComboHeader/ComboHeader";
import NativeObject from "../../components/NativeObject/NativeObject";
import { Grid } from "@mui/material";
import { useHistory } from "react-router-dom";

function KpiCard({
  app,
  KPITitle,
  iconId,
  percentageId,
  goalValueId,
  valueId,
  chartTemplate,
  imageId,
  redirectPath,
}) {
  const [showingImage, toggleImage] = useState(false);

  const history = useHistory();

  return (
    <Card
      key={KPITitle}
      style={{
        width: "100%",
        padding: "24px 40px 36px",
        marginBottom: "-8px",
        justifyContent: "center",
        flexDirection: "column",
      }}
    >
      {!showingImage ? (
        <Grid
          container
          style={{
            height: "100%",
          }}
        >
          <Grid
            container
            item
            direction="row"
            justifyContent="space-between"
            alignItems="start"
            style={{
              marginBottom: "-24px",
            }}
          >
            <div
              style={{
                width: "60%",
                height: "100px",
                alignItems: "start",
                display: "flex",
                flexDirection: "row",
                justifyContent: "start",
              }}
            >
              <div
                style={{
                  width: "10%",
                  minWidth: "48px",
                  height: "60%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-start",
                  alignItems: "center",
                  marginLeft: "-10px",
                }}
              >
                {/* ICON*/}
                <NativeObject
                  app={app}
                  key={iconId}
                  reference={{ id: iconId }}
                />
              </div>

              <div
                style={{
                  width: "80%",
                  alignContent: "center",
                  display: "flex",
                  padding: "20px 0 0 4px",
                }}
              >
                {/* TITULO */}
                <ComboHeader
                  reference={{
                    title: {
                      hard: KPITitle,
                    },
                  }}
                />
              </div>
            </div>
            {imageId && (
              <Grid
                container
                item
                direction={"column"}
                justifyContent={"start"}
                alignItems="end"
                style={{
                  display: "flex",
                  width: "20%",
                }}
              >
                <button
                  style={{
                    background: "#FFFFFF",
                    height: "32px",
                    width: "100px",
                    border: "1px solid #E6E6E6",
                    borderRadius: "6px",
                    fontSize: "10px",
                    fontWeight: "500",
                  }}
                  type="button"
                  onClick={() => toggleImage(!showingImage)}
                >
                  <span>SORTIMENTO&nbsp;&nbsp;</span>
                  <i className="fas fa-expand"></i>&nbsp;
                </button>
              </Grid>
            )}
          </Grid>

          <Grid
            container
            item
            spacing={3}
            columns={16}
            style={{
              height: "100%",
            }}
          >
            <Grid item xs={12}>
              <div
                className="containerKpiValueBold"
                style={{
                  width: "85%",
                  height: "36%",
                  display: "flex",
                  flexDirection: "column",
                  marginBottom: "-24px",
                }}
              >
                <span
                  style={{
                    fontSize: "16px",
                    fontWeight: "500",
                    color: "#8A8A8A",
                    paddingBottom: "6px",
                  }}
                >
                  META
                </span>
                {/* VALOR META */}
                <NativeObject
                  className="kpiValueBold"
                  app={app}
                  key={goalValueId}
                  reference={{ id: goalValueId }}
                />
              </div>
              <div
                style={{
                  width: "85%",
                  height: "14%",
                  display: "flex",
                  flexDirection: "row",
                  marginBottom: "6px",
                }}
              >
                <NativeObject
                  // INDICADOR PORCENTAGEM
                  className={"percentageBadge"}
                  app={app}
                  key={percentageId}
                  reference={{ id: percentageId }}
                />
              </div>
              <div
                className="containerKpiValueGrey"
                style={{
                  display: "flex",
                  height: "36%",
                  flexDirection: "column",
                  marginBottom: "-16px",
                }}
              >
                <span
                  style={{
                    fontSize: "16px",
                    fontWeight: "500",
                    color: "#8A8A8A",
                    paddingBottom: "6px",
                  }}
                >
                  REALIZADO
                </span>
                {/* VALOR REALIZADO */}
                <NativeObject
                  className="kpiValueGrey"
                  app={app}
                  key={valueId}
                  reference={{ id: valueId }}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  height: "14%",
                  width: "40%",
                }}
              >
                <button
                  style={{
                    background: "#FFFFFF",
                    height: "32px",
                    width: "100px",
                    border: "1px solid #E6E6E6",
                    borderRadius: "6px",
                    fontSize: "10px",
                    fontWeight: "500",
                  }}
                  type="button"
                  onClick={() => history.push(redirectPath)}
                >
                  <i className="fas fa-plus"></i>
                  <span>&nbsp;&nbsp;DETALHES</span>
                </button>
              </div>
            </Grid>

            <Grid item xs={4}>
              <div
                style={{
                  maxWidth: "260%",
                  height: "100%",
                  margin: "-24px 36px 0px -120px",
                  flexDirection: "column",
                  flexGrow: 1,
                }}
              >
                {chartTemplate}
              </div>
            </Grid>
          </Grid>
        </Grid>
      ) : (
        <Grid
          container
          direction={"column"}
          justifyContent={"flex-start"}
          alignItems={"start"}
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
          }}
        >
          <Grid
            item
            container
            direction="row-reverse"
            justifyContent="flex-start"
            alignItems="flex-start"
            style={{ width: "100%", height: "5%", display: "flex" }}
          >
            <Grid item>
              <button
                type="button"
                className="buttonClose"
                onClick={() => toggleImage(!showingImage)}
              >
                <i className="fal fa-times" />
              </button>
            </Grid>
          </Grid>
          <Grid item style={{ width: "100%", height: "70%", display: "flex" }}>
            <NativeObject
              // BOTTLES IMAGE
              app={app}
              key={imageId}
              reference={{ id: imageId }}
            />
          </Grid>

          <Grid
            item
            container
            direction={"row"}
            justifyContent={"space-between"}
            alignItems={"center"}
            style={{ width: "100%", height: "25%", display: "flex" }}
          >
            <Grid
              item
              container
              direction={"column"}
              justifyContent={"flex-start"}
              alignItems={"flex-start"}
              style={{ width: "100%", height: "100%", display: "flex" }}
              xs={6}
            >
              <Grid
                item
                container
                xs={6}
                className="containerKpiValueBold"
                style={{ width: "100%", height: "100%", display: "flex" }}
                rowGap={0.5}
              >
                <Grid item xs={12}>
                  <span
                    style={{
                      fontSize: "16px",
                      fontWeight: "500",
                      color: "#8A8A8A",
                    }}
                  >
                    META
                  </span>
                </Grid>
                <Grid
                  item
                  xs={12}
                  style={{ width: "100%", height: "100%", display: "flex" }}
                >
                  {/* VALOR META */}
                  <NativeObject
                    className="kpiValueBold kpiValueSmall"
                    app={app}
                    key={goalValueId}
                    reference={{ id: goalValueId }}
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  style={{ width: "100%", height: "100%", display: "flex", marginTop: "-2px" }}
                >
                  <NativeObject
                    // INDICADOR PORCENTAGEM
                    className={"percentageBadge"}
                    app={app}
                    key={percentageId}
                    reference={{ id: percentageId }}
                  />
                </Grid>
              </Grid>
            </Grid>

            <Grid
              item
              container
              xs={6}
              className="containerKpiValueGrey"
              style={{ width: "100%", height: "100%", display: "flex" }}
            >
              <Grid item xs={12}>
                <span
                  style={{
                    fontSize: "16px",
                    fontWeight: "500",
                    color: "#8A8A8A",
                  }}
                >
                  REALIZADO
                </span>
              </Grid>
              <Grid
                item
                xs={12}
                style={{ width: "100%", height: "100%", display: "flex" }}
              >
                {/* VALOR REALIZADO */}
                <NativeObject
                  className="kpiValueGrey kpiValueSmall"
                  app={app}
                  key={valueId}
                  reference={{ id: valueId }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      )}
    </Card>
  );
}

KpiCard.defaultProps = {
  app: null,
  KPITitle: "",
  iconId: null,
  percentageId: null,
  goalValueId: null,
  valueId: null,
  chartTemplate: null,
  redirectPath: "",
};

KpiCard.propTypes = {
  app: PropTypes.object,
  KPITitle: PropTypes.string,
  iconId: PropTypes.string,
  percentageId: PropTypes.string,
  goalValueId: PropTypes.string,
  valueId: PropTypes.string,
  chartTemplate: PropTypes.object,
  redirectPath: PropTypes.string,
};

export default KpiCard;
